export default __webpack_public_path__ + "static/media/motor-teal.d16952c5.png";